var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c(
        "div",
        {
          staticClass: "profile__edit--feedback error",
          class: { open: _vm.errorNotification.show }
        },
        [
          _vm._v(" " + _vm._s(_vm.$t(_vm.errorNotification.message)) + " "),
          _c("span", {
            staticClass: "glicon-close-large error-close",
            on: { click: _vm.close }
          })
        ]
      ),
      _c(
        "div",
        {
          staticClass: "profile__edit--feedback",
          class: { open: _vm.successNotification.show }
        },
        [
          _c("span", { staticClass: "glicon-check-circle" }),
          _c("span", [_vm._v(_vm._s(_vm.$t(_vm.successNotification.message)))])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }